export default __webpack_public_path__ + "static/media/gasag_logo.f241f421.svg";